<template>
    <!--Portfolio Videos Container-->
    <section class="portfolio-videos">
        <div v-if="user && user.role == 'stylist' && user.id != 35321" class="section-wrap">
            <h4>You don't have permission to visit this page</h4>
        </div>
        <div v-if="user && user.role == 'stylist' && user.id === 35321" class="portfolio-container">
            <div class="portfolio-heading">
                <h2>{{ $t("portfolio.videos") }}</h2>
            </div>

            <!--Portfolio Videos Container-->
            <div class="container-wrapper section-wrap">
                <!--Add Video-->
                <div class="get-featured-wrapper">
                    <h5>Get Featured</h5>
                    <p>Introduce yourself to future clients with a short
                        professional video. Featured videos appear on your
                        profile and may be promoted across our platform.</p>
                </div>

                <!--Portfolio Video-->
                <div v-if="portfolioVideo.src && portfolioVideo.state == 'approved'" class="video-inner-container">
                    <div class="video-inner">
                        <iframe width="560" height="315" :src="portfolioVideo.src" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                    </div>
                    <div class="actions-block">
                        <button type="button" id="delete-btn" v-on:click="deleteVideo">Delete</button>
                    </div>
                </div>

                <p v-if="newVideo.file">{{newVideo.file.name}}</p>
                <p v-if="portfolioVideo.state == 'pending'">Video pending for approval.</p>
                <p v-if="portfolioVideo.state == 'deleted'">Video deleted.</p>
                <p v-if="!authorizationCodeGenerated">You need to generate an OAuth code to upload videos.</p>

                <!-- Form -->
                <form action="" method="POST" enctype="multipart/form-data" class="form-wrapper" v-if="(portfolioVideo.state == 'deleted' || !portfolioVideo.state) && authorizationCodeGenerated">
                    <!-- Choose file -->
                    <input type="file" ref="inputRef" id="video" class="choose-file" name="video" accept="video/mp4" @change="handleFileChange" required hidden>

                    <div class='upload-video-container' v-on:click="focusInput">
                        <svg width="60" height="60" viewBox="0 0 60 48" fill="none" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <circle r="30" cx="30" cy="24" fill="lightgray" stroke="none"></circle>
                            <rect x="15" y="15" width="20" height="14" rx="2" />
                            <polygon points="42,15 35,22 42,29" fill="none"/>
                        </svg>
                        <b>Upload Your Intro Video</b>
                        <p>Drag & drop or click to upload</p>
                    </div>

                    <ul class="video-conditions">
                        <li>Max 30 sec</li>
                        <li>MP4</li>
                        <li>No copyrighted music</li>
                    </ul>

                    <div class="input-checkbox">
                        <div class="input-box">
                            <input class="checkbox" type="checkbox" id="consent" name="consent" @change="handleConsentAccepted" required>
                        </div>
                        <label for="consent" class="confirm-label">
                            <span class="checkbox-title">I confirm that I own the rights to this video and allow it to be published.</span>
                        </label>
                    </div>
                    <div class="full-terms-paragraph" v-on:click="toggleDisplayTerms">
                        <p class="no-margin-paragraph">View full terms</p>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!displayTerms">
                            <path d="M0 0 L5 10 L10 0" stroke="#14B8A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="displayTerms">
                            <path d="M0 10 L5 0 L10 10" stroke="#14B8A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div v-if="displayTerms" class="legal-consent">{{legalConsent ? legalConsent : "No legal consent"}}</div>
                    <div class="upload-button-wrapper">
                        <button class="primary-btn extra-small mobile" v-on:click="uploadVideo" type="button"
                        name="upload" id="upload">Upload video</button>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>

import api from "../../services/apiEndpoints.js";
import auth from "./../../services/auth.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";
import $ from "jquery";


export default {
    name: "PortfolioVideos",
    data() {
        return {
            user: null,
            legalConsent: "",
            portfolioVideo: {
                src: null,
                state: null
            },
            displayTerms: false,
            newVideo: {
                file: null
            },
            consentAccepted: false,
            authorizationCodeGenerated: false,
        };
    },
    mounted() {
        this.user = auth.state.user;
        this.handleCallback();
    },
    methods: {
        getPortfolioVideo() {

            let data = {user_id: "" + this.user.id};

            this.$http.post(api.actions.get_video_src, data).then((res) => {
                if (!res.data.error && res.data.state == 'approved') {
                    this.portfolioVideo.src = res.data.video_src;
                    this.portfolioVideo.state = res.data.state;
                } else if (!res.data.error) {
                    this.portfolioVideo.state = res.data.state;
                } else {
                    messages.errorMessage(res.data.message);
                }
            });
        },
        getLegalConsentText() {
            this.$http.get(api.actions.get_legal_consent_text).then((res) => {
                this.legalConsent = res.data.consent_text;
            });
        },
        toggleDisplayTerms() {
            this.displayTerms = !this.displayTerms;
        },
        focusInput() {
            this.$refs.inputRef.click();
        },
        handleFileChange(e) {
            this.newVideo.file = e.target.files[0];
            this.portfolioVideo.state = null;
        },
        handleConsentAccepted() {
            this.consentAccepted = !this.consentAccepted;
        },
        uploadVideo() {
            let formData = new FormData();
            formData.append('video', this.newVideo.file);
            formData.append('source_app', this.generalOptions.app_name);
            formData.append('upload_method', 'server_direct');
            formData.append('consent_accepted', this.consentAccepted);
            
            this.$http.post(api.actions.upload_video, formData, {
                emulateJSON: false,
                transformRequest: [(data) => data],
                timeout: 0
            })
            .then(res => {
                if(res.data.error){
                    messages.errorMessage(res.data.message);
                } else {
                    messages.successMessage(messages.GLOBAL_MESSAGES.VIDEO_UPLOAD_SUCCESS);
                    this.newVideo = {
                        file: null
                    }
                    this.getPortfolioVideo();
                }
            });
        },
        deleteVideo() {
            let urlParts = this.portfolioVideo.src.split("/");
            let ytVideoId = urlParts[4];
            
            let data = {"youtube_video_id" : ytVideoId, "from_rms" : 'true'}; 

            this.$http.post(api.actions.delete_video, data).then((res) => {
                if(!res.data.error){
                    messages.successMessage(res.data.message);
                    this.portfolioVideo.src = null;
                    this.portfolioVideo.state = 'deleted';
                } else {
                    messages.errorMessage(res.data.message);
                }
            })
        },
        handleCallback() {

            let urlCode = new URLSearchParams(window.location.search).get("code");
            if(urlCode){
                this.authorizationCodeGenerated = true;

                let data = {"code": urlCode};

                this.$http.post(api.actions.handle_callback, data).then((res) => {
                    if(!res.data.error){
                        messages.successMessage(res.data.message);
                        this.getPortfolioVideo();
                        this.getLegalConsentText();
                    } else {
                        messages.errorMessage(res.data.message);
                    }
                });
            }
            else {
                this.$http.get(api.actions.tokens_created).then((res) => {
                    if(res.data.tokens_created){
                        this.authorizationCodeGenerated = true;
                        this.getPortfolioVideo();
                        this.getLegalConsentText();
                    }
                })     
            }
        }
    },
};
</script>